export const buildEncodedToken = (user, decryptedPassword) =>
  Buffer.from(`${user}:${decryptedPassword}`).toString('base64');
